<template>
  <div v-if="show" class="odp_model">
    <template v-for="(item, index) in table">
      <o-vData
        v-if="item['data']"
        :key="item.id"
        :lineIndex="index"
        :lineData="item"
        :func_input="inputChange"
        :func_click="func_SPEC_S"
      />
      <o-vDataMulti
        v-else-if="item['data_multi']"
        :key="item.id"
        :lineIndex="index"
        :lineData="item"
        :func_input="inputChange"
        :func_click="func_SPEC_S"
      />
      <o-vDataAfter
        v-else-if="item['data_after']"
        :key="item.id"
        :lineIndex="index"
        :lineData="item"
        :func_input="inputChange"
        :func_click="func_SPEC_S"
      />
    </template>
  </div>
</template>
<script>
import { gain_produce } from "@/seal/proCardSet";

export default {
  name: "tijianbaogao", //体检报告
  components: {},
  props: {},
  data() {
    return {
      pid: "pidcards_bzdah",
      show: false,
      table: {},
    };
  },
  methods: {
    showChange() {
      // 获取表单
      const produce = gain_produce(this["pid"]);
      if (produce["table"]) {
        this.table = produce["table"];
      } else {
        return;
      }

      this.show = true;
    },
    closeChange() {
      this.show = false;
    },
    //输入框完成事件
    inputChange(event) {
      const params = this.func_tidyParams();
      this.$parent.func_quotation(this.pid, params);
    },
    //点击产品规格-汇总
    func_SPEC_S(event) {
      const type = event.currentTarget.dataset.type;
      const index = event.currentTarget.dataset.index;
      const seq = event.currentTarget.dataset.seq;
      if (!this.table[index] || !this.table[index][type]) return;
      switch (type) {
        case "data": {
          //当前点击行的所有参数规格
          let data = this.table[index][type];
          if (data[seq]["choose"] && data[seq]["type"] !== "select") return;

          // 点击区域属-'下拉框'
          if (data[seq]["type"] === "select") {
            const select_index = event.currentTarget.dataset.select_index;
            if (select_index) {
              data[seq]["name"] =
                data[seq]["select_data"][select_index]["name"];
              data[seq]["value"] =
                data[seq]["select_data"][select_index]["value"];
            }
            if (
              data[seq]["select_data"][select_index] &&
              data[seq]["select_data"][select_index]["src"]
            ) {
              this.$parent.func_picture(
                data[seq]["select_data"][select_index]["src"]
              );
            }
          }

          // 切换已选中的'下拉框'的内容时-不需要执行
          if (!data[seq]["choose"]) {
            for (let i in data) {
              if (data[i]["choose"]) {
                data[i]["choose"] = false;
                data[seq]["choose"] = true;
                break;
              }
            }
          }
          if(data[seq].name.indexOf('横版') > 0){
            this.$parent.func_picture2(1)
          }else if(data[seq].name.indexOf('竖版') > 0){
            this.$parent.func_picture2(2)
          }else if(data[seq].name.indexOf('开窗') > 0){
            this.$parent.func_picture2(3)
          }else{
            this.$parent.func_picture2(4)
          }
          if (
            index === "p_chengpinchicun" &&
            data[seq].choose &&
            (data[seq].name == "体检报告袋竖版(229X324X33mm)" ||
              data[seq].name == "体检报告袋横版(324X229X45mm)")
          ) {
            this.table.p_houdaogongxu.data_after[1].data[0].choose = true;
            this.table.p_houdaogongxu.data_after[2].data[0].choose = false;
            this.table.p_houdaogongxu.data_after[3].data[0].choose= true;
            this.table.p_danshuangmian.data = [
              { type: "default", name: "单面", value: "1", choose: true },
            ];
            this.table.p_cailiao.data_multi = [
              {
                type: "select",
                name: "灰底白(白板)",
                value: "6",
                choose: true,
                level: "1",
                select_show: false,
                select_data: [
                  { name: "双胶纸", value: "5" },
                  { name: "黄牛皮", value: "9" },
                  { name: "白牛皮", value: "14" },
                  { name: "双铜纸", value: "1" },

                  { name: "单铜纸(白卡)", value: "2" },
                  { name: "灰底白(白板)", value: "6" },
                  { name: "哑粉纸", value: "3" },
                  { name: "冰白珠光纸", value: "13" },
                ],
              },
              {
                type: "select",
                name: "300克",
                value: 300,
                choose: true,
                level: "2",
                select_show: false,
                // 灰底白(白板)
                select_data: [
                  { name: "250克", value: 250 },
                  { name: "300克", value: 300 },
                  { name: "350克", value: 350 },
                  { name: "400克", value: 400 },
                  { name: "450克", value: 450 },
                ],
              },
            ];
          } else if (
            index === "p_chengpinchicun" &&
            data[seq].choose &&
            (data[seq].name == "体检报告封面(213X297X3书脊mm)" ||
              data[seq].name == "体检报告封面开窗款(213X297X3书脊mm)") &&
            this.table.p_danshuangmian.data.length < 2
          ) {
            this.table.p_danshuangmian.data = [
              { type: "default", name: "双面", value: "2", choose: false },
              { type: "default", name: "单面", value: "1", choose: true },
            ];
            this.table.p_houdaogongxu.data_after[1].data[0].choose = true;
            this.table.p_houdaogongxu.data_after[2].data[0].choose = true;
            this.table.p_houdaogongxu.data_after[3].data[0].choose = false;
          } else if (
            index === "p_chengpinchicun" &&
            data[seq].choose &&
            (data[seq].name == "体检报告封面(213X297X3书脊mm)" ||
              data[seq].name == "体检报告封面开窗款(213X297X3书脊mm)")
          ) {
            this.table.p_houdaogongxu.data_after[1].data[0].choose = true;
            this.table.p_houdaogongxu.data_after[2].data[0].choose = true;
            this.table.p_houdaogongxu.data_after[3].data[0].choose = false;
            this.table.p_cailiao.data_multi = [
              {
                type: "select",
                name: "单铜纸(白卡)",
                value: "2",
                choose: true,
                level: "1",
                select_show: false,
                select_data: [
                  { name: "双胶纸", value: "5" },
                  { name: "黄牛皮", value: "9" },
                  { name: "白牛皮", value: "14" },
                  { name: "双铜纸", value: "1" },
                  { name: "单铜纸(白卡)", value: "2" },
                  { name: "哑粉纸", value: "3" },
                  { name: "冰白珠光纸", value: "13" },
                ],
              },
              {
                type: "select",
                name: "250克",
                value: 250,
                choose: true,
                level: "2",
                select_show: false,
                select_data: [
                  { name: "190克", value: 190 },
                  { name: "210克", value: 210 },
                  { name: "230克", value: 230 },
                  { name: "250克", value: 250 },
                  { name: "300克", value: 300 },
                  { name: "350克", value: 350 },
                ],
              },
            ];
          }
          if (index === "p_chengpinchicun") {
            if (data[seq]["type"] === "custom2") {
              // 自定义尺寸-只能选'定制刀模'
              this.table["p_daomo"]["data"] = [
                { type: "default", name: "定制刀模", value: "1", choose: true },
              ];
              this.table.p_houdaogongxu.data_after.push(
                  {
                    container: 'hjgzdy6',
                    must: false,
                    data: [
                      { type: 'default', name: '粘单底兜', value: '15400', choose: false },
                    ]
                  },
                  {
                    container: 'hjgzdy7',
                    must: false,
                    data: [
                      { type: 'default', name: '粘双底兜', value: '15401', choose: false },
                    ]
                  },
                 )
              
            } else if (this.table["p_daomo"]["data"].length < 2) {
              
              this.table["p_daomo"]["data"] = [
                { type: "default", name: "标准刀模", value: "0", choose: true },
              ];
              if(this.table.p_houdaogongxu.data_after.length == 15){
                this.table.p_houdaogongxu.data_after.splice(-2, 2);
              }

            }
          }
          break;
        }
        case "data_multi": {
          const level = event.currentTarget.dataset.level;
          const select_index = event.currentTarget.dataset.select_index;
          let data = this.table[index][type];
          if (!level) return;

          data[seq]["name"] = data[seq]["select_data"][select_index]["name"];
          data[seq]["value"] = data[seq]["select_data"][select_index]["value"];
          if (level === "1") {
            // 切换二级内容
            data[1]["select_data"] =
              this.table[index]["multi_list"][select_index];
            data[1]["name"] = data[1]["select_data"][0]["name"];
            data[1]["value"] = data[1]["select_data"][0]["value"];
          }
          break;
        }
        case "data_after": {
          const se = event.currentTarget.dataset.se;
          const select_index = event.currentTarget.dataset.select_index;
          let data = this.table[index][type];
          if (data[seq]["must"] && data[seq]["data"][se]["choose"]) return;

          let in_data = data[seq]["data"];

          if (select_index !== undefined) {
            in_data[se]["name"] =
              in_data[se]["select_data"][select_index]["name"];
            in_data[se]["value"] =
              in_data[se]["select_data"][select_index]["value"];
          }

          if (data[seq]["must"]) {
            // 当前行为-必选
            for (let i in in_data) {
              if (in_data[i]["choose"]) {
                in_data[i]["choose"] = false;
                in_data[se]["choose"] = true;
                break;
              }
            }
          } else {
            // 当前行为-非必选
            if (in_data[se]["choose"] && select_index === undefined) {
              in_data[se]["choose"] = false;
            } else {
              for (let i in in_data) {
                if (in_data[i]["choose"]) {
                  in_data[i]["choose"] = false;
                  break;
                }
              }
              in_data[se]["choose"] = true;
            }
          }

          break;
        }
        default: {
          return;
        }
      }

      // 整合规格参数，请求报价
      const params = this.func_tidyParams();
      this.$parent.func_quotation(this.pid, params);
    },
    // 整理参数
    func_tidyParams() {
      let result = {
        need_QQoffer: false, //需QQ另行计价
        string: "体检报告-", //报价内容
        hjg: [],
        // SysCode: 'Web',
        vid: 0,
        gvip: 0,
        pid: 0,
        isdiy: 1,
        labelVal: 0,
        qid: 11,
        jidaohen: 1,
        gvip: null,
        p: 0,
        prh: 0,
        kuans: 1,
        sjlx: 2,
        byx: 1,
        zeye: "对折",
        yhlx: "压痕不折",
        hjghmgs: 1,
        hmjls: 0,
        hjgjjs: 50,
        Serch0: 0,
        danshuang: 1,
        Serch1: 0,
        Serch2: 0,
        province: "广东",
        city: "广州",
        hjgzdycount: 13,
        Printer_Test: 0,
        PSList: 0,
        hjgother: 1,
      };

      for (let i in this.table) {
        // 当前行
        const line_name = i;
        // 当前行类型
        let line_type = this.table[i]["data"]
          ? "data"
          : this.table[i]["data_multi"]
          ? "data_multi"
          : this.table[i]["data_after"]
          ? "data_after"
          : false;
        if (!line_type) return;

        const data = this.table[i][line_type];
        switch (line_type) {
          // 面板一(普通)
          case "data": {
            const container = this.table[i]["container"];
            if (!container) return;
            for (let j in data) {
              // 行中选中的块
              if (data[j]["choose"]) {
                // 文字内容提示
                if (line_name === "p_yinshuashuliang") {
                  result["string"] += data[j]["value"] + "个-";
                } else if (
                  line_name === "p_chengpinchicun" &&
                  data[j]["type"] === "custom2"
                ) {
                  const x = data[j]["value"][0];
                  const y = data[j]["value"][1];
                  result["string"] += data[j]["name"] + x + "×" + y + "-";
                } else {
                  result["string"] += data[j]["name"] + "-";
                }

                // 常规处理
                if (container.constructor["name"] === "String") {
                  result[container] = data[j]["value"];
                } else if (container.constructor["name"] === "Array") {
                  for (let c in container) {
                    result[container[c]] = data[j]["value"][c];
                  }
                }
                break;
              }
            }
            break;
          }
          // 面板二(多行)
          case "data_multi": {
            const container = this.table[i]["container"];
            if (!container) return;
            for (let c in container) {
              // 文字内容提示
              result["string"] += data[c]["name"] + "-";

              result[container[c]] = data[c]["value"];
            }
            break;
          }
          // 面板二(后道工序)
          case "data_after": {
            for (let j in data) {
              const in_data = data[j]["data"];
              for (let k in in_data) {
                if (in_data[k]["choose"]) {
                  // 文字内容提示
                  if (
                    in_data[k]["name"] === "烫金" ||
                    in_data[k]["name"] === "烫银" ||
                    in_data[k]["name"] === "局部UV" ||
                    in_data[k]["name"] === "击凸"
                  ) {
                    const x = in_data[k]["value"][0];
                    const y = in_data[k]["value"][1];
                    result["string"] +=
                      in_data[k]["name"] +
                      x +
                      "×" +
                      y +
                      in_data[k]["unit"] +
                      "-";
                  } else if (
                    in_data[k]["name"].substring(0, 1) === "烫" &&
                    in_data[k]["custom2"]
                  ) {
                    const x = in_data[k]["value"][0];
                    const y = in_data[k]["value"][1];
                    result["string"] +=
                      in_data[k]["name"] +
                      x +
                      "×" +
                      y +
                      in_data[k]["unit"] +
                      "-";
                  } else {
                    result["string"] += in_data[k]["name"] + "-";
                  }

                  const container = data[j]["container"];
                  if (!container) return;
                  if (container === "hjg") {
                    result["hjg"].push(in_data[k]["value"]);
                  } else if (container.constructor["name"] === "String") {
                    result[container] = in_data[k]["value"];
                  } else if (container.constructor["name"] === "Array") {
                    for (let c in container) {
                      if (container[c] === "hjg") {
                        result["hjg"].push(in_data[k]["value"][c]);
                      } else {
                        result[container[c]] = in_data[k]["value"][c];
                      }
                    }
                  }
                  break;
                }
              }
            }
            break;
          }
          default:
            return;
        }
      }
      if (result.hjgzdy4 == "31686") {
        result.hjgzdy10 = 31686;
        delete result["hjgzdy4"];
      }
      for (let i in result.hjg) {
        if (result.hjg[i] == "31687") {
          result.hjgzdy11 = "31687";
          delete result.hjg[i];
        } else if (result.hjg[i] == "31688") {
          result.hjgzdy11 = "31688";
          delete result.hjg[i];
        }
      }
      if (result["string"].endsWith("-")) {
        result["string"] = result["string"].substring(
          0,
          result["string"].length - 1
        );
      }
      result.materialname = this.table.p_cailiao.data_multi[0].name;
      return result;
    },
  },
  mounted() {},
};
</script>
<style src='@/style/orderProduct.css'></style>




// WEBPACK FOOTER //
// src/pages/order/v2020/bzdah.vue